import {Trans} from "@lingui/macro";
import {DemoChangeData, DemoCustomColor} from "../../components/Diagrams";
import React, {FC, useEffect, useState} from "react";
import {Breadcrumb, Card, Col, Row, Statistic} from "antd";
import {ArrowUpOutlined, TeamOutlined} from "@ant-design/icons/lib";
import {ArrowDownOutlined, LikeOutlined, ShoppingCartOutlined} from "@ant-design/icons";
import {AxiosResponse} from "axios";
import moment from "moment/moment";
import {openNotification} from "../../utils/openNotification";
import {useAxios} from "../../utils/hooks";
import OrdersList from "../../components/OrdersList";
import keycloak from "../../keycloak";

const DashboardScreen: FC = () => {

    const axiosInstance = useAxios(process.env.REACT_APP_API_BASE_URL + "");
    const [countOfUsers, setCountOfUsers] = useState<any>(0);
    const [supplierIsEu, setSupplierIsEu] = useState<boolean>(false);
    const [isGlobalAdmin, setIsGlobalAdmin] = useState<boolean>(false);

    useEffect(() => {
        const roles = (keycloak.realmAccess && keycloak.realmAccess.roles) || [];
        setIsGlobalAdmin(roles.includes('EUDR_ADMIN'));
        
        if(localStorage.getItem('supplierCode') == 'undefined') {
            getMyAllUser();
        }
        
        getSupplierInfo();
    }, []);
    const getMyAllUser = () => {
        if (axiosInstance.current != null) {
            axiosInstance.current
                .get('/resource/users/get-my-all-users', {})
                .then(function (response : AxiosResponse<any>) {
                    setCountOfUsers(response.data.length);
                })
                .catch(function (error) {
                    openNotification('error', error);
                })
                .finally(() => {
                });
        }
    };
    
    const getSupplierInfo = () => {
        if (axiosInstance.current != null) {
            const supplierCode = localStorage.getItem('supplierCode');
            if (supplierCode && supplierCode !== 'undefined') {
                axiosInstance.current
                    .get('/resource/suppliers/' + supplierCode)
                    .then(function (response : AxiosResponse<any>) {
                        setSupplierIsEu(response.data.isEu || false);
                    })
                    .catch(function (error) {
                        console.log('Failed to fetch supplier info:', error);
                    });
            }
        }
    };
return (
    <>
        <>
            <Row gutter={24}>
                <Col span={24}>
                    <h2>
                        <h2><Trans>Welcome to the EUDR portal</Trans></h2>
                    </h2>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={8}>
                    <Card style={{backgroundColor: '#d9f7be'}}>
                        <Statistic
                            title={<Trans>Awaiting delivery / Sum of Orders</Trans>}
                            value={0}
                            suffix={'/ ' + 0}
                        />
                        <Statistic
                            title={<Trans>Percent</Trans>}
                            value={0}
                            precision={0}
                            valueStyle={{color: '#3f8600'}}
                            suffix="%"
                        />
                    </Card>
                </Col>
                <Col span={8}>
                    <Card style={{backgroundColor: '#fff1b8'}}>
                        <Statistic
                            title={<Trans>Expired Loc. Rules / Sum of Loc. Rules</Trans>}
                            value={0}
                            suffix={'/ ' + 0}
                        />
                        <Statistic
                            title={<Trans>Percent</Trans>}
                            value={0}
                            precision={0}
                            valueStyle={{color: '#d48806'}}
                            suffix="%"
                        />
                    </Card>
                </Col>
                <Col span={8}>
                    <Card style={{backgroundColor: '#ffd8bf'}}>
                        <Statistic
                            title={<Trans>Expired DDS numbers / Sum of DDS numers</Trans>}
                            value={0}
                            suffix={'/ ' + 0}
                        />
                        <Statistic
                            title={<Trans>Percent</Trans>}
                            value={0}
                            precision={0}
                            valueStyle={{color: '#cf1322'}}
                            suffix="%"
                        />
                    </Card>
                </Col>
            </Row>
            <br/>
            <Row gutter={24}>
                <Col span={12}>
                    <h2>
                        <Trans>My Orders</Trans>
                    </h2>
                </Col>
                <Col span={8}>
                    <h2>
                        <Trans>My Users</Trans>
                    </h2>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={12}>
                    <OrdersList
                        supplierIsEu={supplierIsEu}
                        isGlobalAdmin={isGlobalAdmin}
                    />
                </Col>
                <Col span={8} style={{cursor: 'pointer'}}>
                    <Card onClick={() => alert('')}>
                        <Col span={12}>
                            <Statistic
                                value={countOfUsers}
                                prefix={<TeamOutlined/>}
                            />
                        </Col>
                    </Card>
                </Col>
            </Row>
            <br/>
            <Row gutter={24}>

            </Row>
            <Row gutter={24}>

            </Row>
        </>

    </>
);

}
export default DashboardScreen;